// W-0821 — Barra de ações em lote sobre a seleção atual.
// LICOES W-0510 L5 — pattern BulkActionBar (visível só com >0 selecionados).
// LICOES Ciclo 9 L6 — limite de lote validado no Controller (LIMITE_LOTE_BOLETOS).

import React from 'react';
import { Card, Button, Badge } from 'react-bootstrap';
import { FaUserPlus, FaTimes, FaCheckCircle } from 'react-icons/fa';
import { LIMITE_LOTE_BOLETOS } from '~/constant';

const BulkActionBar = ({
  selecionados,
  totalAtribuidos,
  totalSelecionado,
  onAbrirAtribuirLote,
  onLimparSelecao,
  onLancar,
  podeLancar,
}) => {
  if (selecionados.length === 0) return null;

  const limiteExcedido = totalAtribuidos > LIMITE_LOTE_BOLETOS;

  return (
    <Card className="mb-3 shadow-sm border-primary">
      <Card.Body className="d-flex flex-wrap align-items-center justify-content-between" style={{ gap: 8 }}>
        <div>
          <Badge bg="primary" className="me-2">
            {selecionados.length} selecionado(s)
          </Badge>
          <Badge bg="success" className="me-2">
            {totalAtribuidos} com cobrador atribuído
          </Badge>
          {limiteExcedido && (
            <Badge bg="warning" text="dark">
              Limite de {LIMITE_LOTE_BOLETOS} por lote — será enviado em chunks
            </Badge>
          )}
        </div>
        <div className="d-flex flex-wrap" style={{ gap: 8 }}>
          <Button
            size="sm"
            variant="outline-primary"
            onClick={onAbrirAtribuirLote}
          >
            <FaUserPlus /> Atribuir cobrador ao lote
          </Button>
          <Button size="sm" variant="outline-secondary" onClick={onLimparSelecao}>
            <FaTimes /> Limpar seleção
          </Button>
          <Button
            size="sm"
            variant="success"
            disabled={!podeLancar}
            onClick={onLancar}
            title={
              !podeLancar
                ? 'Atribua cobrador a todos os boletos selecionados para lançar'
                : `Lançar ${totalAtribuidos} boleto(s) (em chunks de ${LIMITE_LOTE_BOLETOS})`
            }
          >
            <FaCheckCircle /> Lançar {totalSelecionado} boleto(s)
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default BulkActionBar;
